export const isVoyageReadOnly = (voyage) =>
  Boolean(voyage && voyage.status !== "active");

export const isVoyageEditable = (voyage) =>
  Boolean(voyage && voyage.status === "active");
